import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (param) {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '',
    name: 'hiveManageGet',
    method: 'GET',
  });

  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = '/api/system/loginlogs';
      let arr = [];
      Object.keys(param).forEach(key => {
        arr.push(key + '=' + param[key]);
      });
      if (arr.length !== 0) {
        url += '?' + arr.join('&');
      }
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);
  return [isRequestSuccessed, data || {}, isLoading];
});
